const LOCK_KEY = 'refresh_lock';
const LOCK_TIMEOUT = 10000;

export function setRefreshLock() {
  localStorage.setItem(LOCK_KEY, String(Date.now()));
}

export function clearRefreshLock() {
  localStorage.removeItem(LOCK_KEY);
}

export function isAnotherTabRefreshing() {
  const ts = parseInt(localStorage.getItem(LOCK_KEY), 10);
  return ts && (Date.now() - ts < LOCK_TIMEOUT);
}
